import { Api } from "./Api.jsx";

export const getReceipts = async (filter) => {
  try {
    const response = await Api.get("/receipts", { params: filter });
    return response.data;
  } catch (error) {
    console.error("Error fetching receipts: ", error);
    throw error;
  }
};

export const getReceipt = async (receiptId) => {
  try {
    const response = await Api.get(`/receipts/${receiptId}/`);
    const data = response.data;
    data.etag = response.headers["etag"];
    return data;
  } catch (error) {
    console.error("Error fetching receipts: ", error);
    throw error;
  }
};

export const putReceipt = async (receiptId, receipt, etag) => {
  try {
    const response = await Api.put(`/receipts/${receiptId}`, receipt, { headers: { "If-Match": etag } });
    return response.data;
  } catch (error) {
    console.error("Error fetching receipt: ", error);
    throw error;
  }
};

export const getAcumulado = async (params) => {
  try {
    const response = await Api.get("/receipts/acumulado", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching acumulado: ", error);
    throw error;
  }
};

export const getPrecintas = async (year) => {
  try {
    const response = await Api.get("/receipts/precintas", { params: { year } });
    return response.data;
  } catch (error) {
    console.error("Error fetching precintas: ", error);
    throw error;
  }
};

export const getReceiptPartidas = async (receiptId) => {
  try {
    const response = await Api.get(`/partidas/receipt/${receiptId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching partidas from receipt: ", error);
    throw error;
  }
};

export const getProducts = async () => {
  try {
    const response = await Api.get("/products");
    return response.data;
  } catch (error) {
    console.error("Error fetching products: ", error);
    throw error;
  }
};

export const getProduct = async (productId) => {
  try {
    const response = await Api.get(`/products/${productId}`);
    const data = response.data;
    data.etag = response.headers["etag"];
    return data;
  } catch (error) {
    console.error("Error fetching products: ", error);
    throw error;
  }
};

export const postProduct = async (product) => {
  try {
    const response = await Api.post("/products", product);
    return response.data;
  } catch (error) {
    console.error("Error posting product: ", error);
    throw error;
  }
};

export const putProduct = async (productId, product, etag) => {
  try {
    const response = await Api.put(`/products/${productId}`, product, { headers: { "If-Match": etag } });
    return response.data;
  } catch (error) {
    console.error("Error putting product: ", error);
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
    const response = await Api.delete(`/products/${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting product: ", error);
    throw error;
  }
};
